import { Component, Input, OnInit } from '@angular/core';
import { ApiDomainService } from '@app/core/http/api-domain/api-domain.service';
import { LoadingService } from '@app/core/services/loading/loading.service';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-otp-verify',
  templateUrl: './otp-verify.component.html',
  styleUrls: ['./otp-verify.component.scss'],
})
export class OtpVerifyComponent implements OnInit {

  otpSendBy = ''
  otp = ''
  activeOTP = false;
  otpOption = [];

  @Input() private authData;
  constructor(
    private loadingSvc: LoadingService,
    private translateService: TranslateService,
    private apiDomainSvc: ApiDomainService,
    private modalCtrl: ModalController
  ) { }

  ngOnInit(): void {
    this.otpOption = [];
    if(this.authData?.MfaOption){
      for(const option in this.authData.MfaOption){
        if(this.authData.MfaOption[option]){
          this.otpOption.push(option);
        }
      }
    }
  }

  onSubmit(){
    !this.activeOTP ? this.sendOTP() : this.verifyOTP();
  }

  async sendOTP(){
    if(this.authData){
      const formData = {
        mfaToken: this.authData.mfaToken,
        userId: this.authData.userId,
        userName: this.authData.userName,
      }
      formData[this.otpSendBy.toLowerCase()] = true;
      await this.loadingSvc.present(this.translateService.instant("LOADING"));
      try {
        const response = await this.apiDomainSvc.sendOTP(formData);
        if (response?.status && response?.data) {
          this.activeOTP = true;
        }
      } finally {
        await this.loadingSvc.dismiss();
      }
    }
  }

  async verifyOTP(){
    const formData = {
      otp: this.otp,
    }
    await this.loadingSvc.present(this.translateService.instant("LOADING"));
    try {
      const response = await this.apiDomainSvc.verifyOTP(this.authData.userId, formData);
      if (response?.status && response?.data) {
        this.modalCtrl.dismiss(response?.data) 
      }
    } finally {
      await this.loadingSvc.dismiss();
    }
  }
}
